import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { CampusHeader } from '../Components/CampusHeader';
import { CampusFooter } from '../Components/CampusFooter';
import { CampusFeedback } from './CampusFeedback';
import { CampusQA } from '../Components/CampusQA';

declare var ServerUrlRoot: string;

const openLicense = () => { browserHistory.push(Tgcc.Routes.OtherSchools) }

const FAQHdr: CSSProperties = {
    textAlign: 'center',
    fontFamily: 'BarlowLight',
    color: '#616060'
}
class Question {
    Question: any;
    Content: any;
}
const Or: CSSProperties = {
    letterSpacing: 'normal',
    paddingTop: '16px',
    paddingBottom: '16px',
    textAlign: 'center'
}
const answerStyle: CSSProperties = {
    letterSpacing: 'normal',
    paddingTop: '16px',
    paddingBottom: '16px'
}
const href: CSSProperties = {
    textDecoration: 'underline'
}
const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto auto 200px auto',
    width: '43%'
}

class _CampusHowItWorks extends React.Component<Tgcc.BaseProps, any>{

    state = {
        currentIndex: -1,
    }
    Questions: Question[] = [
        {
            Question: <div>How do I submit a proof?</div>,
            Content: <div style={answerStyle}>Log onto <a style={href} href={ServerUrlRoot}>www.grafcow.com</a> site, click Collegiate/Greek, create an account, and input proof request by clicking <a style={href} href={ServerUrlRoot + "/campus/proofedit"}>GET STARTED</a> button.</div>,
        }, {
            Question: <div>What is your turnaround time to get a proof?</div>,
            Content: (<div style={answerStyle}>
                <div>Standard turnaround time to receive the initial proof is 1-2 business days, depending on the customization of the design.</div>
                <div style={answerStyle}>Once the proof request is ready, an email notification is sent letting you know that the proof is ready to review. You can view, request changes, or approve the design through the email to your <a style={href} href={ServerUrlRoot + "/campus/dashboard"}>dashboard</a>.</div>
                <div style={answerStyle}>Please Note: fully custom designs can take up to 3-4 business days, depending on the complexity of the design.</div>
            </div>

            )
        }, {
            Question: <div>Once I've finalized my proof, how do I place an order?</div>,
            Content: (<div style={answerStyle}>
                <div>Once all changes have been made and the design is finalized, log on to <a style={href} href={ServerUrlRoot + "/campus/dashboard"}>dashboard</a>, log in using your credentials, approve the proof, and the choose the desired payment option.</div>
                <div style={answerStyle}>Classic Order - </div>
                <ul>
                    <li>Choose credit card, check, or purchase order payment option</li>
                    <li>Provide sizes, quantities, and shipping information</li>
                    <li>All orders placed using this method will ship in bulk to the address determined by the main buyer. Shirts are organized by size for easy distribution.</li>
                    <li>Once closed, an invoice will be sent to the main buyer for the entire order.</li>
                </ul>
                <div style={answerStyle}>Tvite & T-Banker (Individual Payment Link) - </div>
                <ul>
                    <li>Estimate order quantity</li>
                    <li>Provide shipping information</li>
                    <li>Your link will be emailed as soon as your design has been approved by licensing.</li>
                    <li>Each individual pays separately and will receive an email confirmation of their order(T-Banker Only).</li>
                    <li>All orders placed using this method will ship in bulk to the address determined by the main buyer and are cowtagged (individually bagged and tagged) with each customer's name for easy distribution.</li>
                </ul>
                <div style={answerStyle}>Once you approve your design and have provided size information and payment preference, we will submit the final design to the appropriate licensing entity (Greek and Collegiate) for final approval. Time will vary depending on response time of each school or organization.</div>
                <div style={answerStyle}>Once the design is approved by licensing, we will:</div>
                <ul>
                    <li>Process the order using the sizes and shipping information provided by you when you approved the design. (Classic Order)</li>
                    <div style={Or}>OR</div>
                    <li>Generate the individual payment link so that participants can begin placing their orders. (Individual Payment Link Option). Once the main buyer has determined that all participants have placed their orders, log back into the <a style={href} href={ServerUrlRoot + "/campus/dashboard"}>dashboard</a> and close the web link so that we can process your order. The order cannot be processed until the web link has been closed by the main buyer.</li>
                </ul>
            </div>
            )
        }, {
            Question: <div>Once I close my order, How long will it take to arrive?</div>,
            Content: (<div style={answerStyle}>
                <div>Once order has closed, the order will be shipped and received by the main buyer within 5-7 business days for orders that are screen-printed and 10-15 business days for orders that require embroidery.</div>
                <div style={answerStyle}>Orders that are needed sooner than our standard turnaround times are subject to a 10% Rush Fee. Please let your Account Manager know if this applies to your order.</div>
                <div>While we strive to deliver all orders within our standard turnaround time, delays can occur due to stock availability. Your Account Manager will let you know if there are any concerns with your order.</div>
            </div>
            )
        }, {
            Question: <div>How do I submit payment for my order?</div>,
            Content: (<div>
                <div style={answerStyle}>Classic Order - We will email the main buyer an invoice for payment once the order has shipped. Payment may be made by mailing a check, paying online using a credit card, or by calling our office (800-472-3269) and providing payment information over the phone. After payment is received, we will issue a paid invoice receipt.</div>
                <div style={answerStyle}>Individual Payment Link Option - We will not send an invoice. Individuals use a credit card or Venmo at the time they place their order.</div>
            </div>
            )
        }
    ];

    componentDidMount() {
        var tag = document.getElementById('FAQ');
        tag.scrollIntoView(false);
    }

    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    handleChange = (i) => {
        if (i === this.state.currentIndex) {
            this.setState({ currentIndex: -1 })
        } else {
            this.setState({ currentIndex: i });
        }

    }


    render() {
        const { handleChange } = this;
        const { currentIndex } = this.state;
        return (
            <div>
                <div id="FAQ"></div>
                <CampusHeader />
                <CampusFeedback state={this.props.state} />
                <div style={containerStyle} className='questionCont'>
                    <h2 style={FAQHdr} className="hdrHIW">How It Works</h2>
                    {this.Questions.map((e, i) => {
                        return (<CampusQA question={e.Question} answer={e.Content} handleChange={handleChange} key={i} index={i} currentIndex={currentIndex} />)
                    })}
                </div>
                <CampusFooter state={this.props.state} />
            </div>

        )
    }
}

const mapStateToProps = (state: Tgcc.GlobalState, ownState: any) => {
    return {
        state: state
    }
};
export var CampusHowItWorks = connect(mapStateToProps)(_CampusHowItWorks)